import React, { useState, useEffect } from "react";
import Header from "../../comps/Header";
import Footer from "../../comps/Footer";
import { useNavigate } from "react-router-dom";
import User_Profile from "../user_profile/User_Profile";
import Order from "../order/Order";
import Address from "../address/Address";

const Account = () => {
  const navigate = useNavigate();
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const userData =
    localStorage.getItem("user") !== "undefined" &&
    JSON.parse(localStorage.getItem("user"));


  // Load category from localStorage (if available), otherwise default to 1
  const [category, setCategory] = useState(() => {
    return localStorage.getItem("selectedCategory")
      ? parseInt(localStorage.getItem("selectedCategory"))
      : 1;
  });

  // Save selected category to localStorage
  const selectCategory = (id) => {
    setCategory(id);
    localStorage.setItem("selectedCategory", id);
  };

  return (
    <>
      <Header />
      <section className="relative py-10 md:py-24">
        <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-transparent" />
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="relative">
            <div className="absolute -inset-4 bg-gradient-to-r from-stone-1000/10 via-transparent to-stone-1000/10 blur-3xl"></div>
            <div className="grid lg:grid-cols-1 gap-6">
              <div className="relative backdrop-blur-xl bg-gray-50/50 rounded-xl p-8 h-full border-1 border-gray-600/10 hover:border-amber-800/50 transition-colors">
                <div>
                  <h2 className="text-2xl font-bold mb-8">My Account</h2>
                  <div className="flex flex-wrap md:space-x-8 w-full">
                    <div className="w-full lg:w-[30%] mb-4">
                      <div className="bg-white rounded-xl p-4">
                        <ul className="grid gap-4 p-0">
                          <li>
                            <span
                              className={`cursor-pointer hover:underline ${category === 1
                                ? "text-black font-bold"
                                : "text-gray-400"
                                }`}
                              onClick={() => selectCategory(1)}
                            >
                              Dashboard
                            </span>
                          </li>
                          <li>
                            <span
                              className={`cursor-pointer hover:underline ${category === 2
                                ? "text-black font-bold"
                                : "text-gray-400"
                                }`}
                              onClick={() => selectCategory(2)}
                            >
                              Orders
                            </span>
                          </li>
                          <li>
                            <span
                              className={`cursor-pointer hover:underline ${category === 3
                                ? "text-black font-bold"
                                : "text-gray-400"
                                }`}
                              onClick={() => selectCategory(3)}
                            >
                              Address
                            </span>
                          </li>
                          <li>
                            <span
                              className={`cursor-pointer hover:underline ${category === 4
                                ? "text-black font-bold"
                                : "text-gray-400"
                                }`}
                              onClick={() => selectCategory(4)}
                            >
                              Account details
                            </span>
                          </li>
                          <li>
                            <span
                              className="cursor-pointer hover:underline text-gray-400"
                              onClick={() => setShowConfirmModal(true)}
                            >
                              Log out
                            </span>
                          </li>

                        </ul>

                      </div>
                    </div>

                    {/* Content Section */}
                    <div className="lg:w-[65%]">
                      {category === 1 && (
                        <div>
                          Hello {userData?.email} (not {userData?.email}? Log
                          out)
                          <p>
                            From your account dashboard, you can view your
                            recent orders and see your account details.
                          </p>
                        </div>
                      )}
                      {category === 2 && (
                        <Order />
                      )}
                      {category === 3 && (
                        <Address />
                      )}
                      {category === 4 && <User_Profile />}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {showConfirmModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-sm">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">Confirm Logout</h2>
            <p className="text-sm text-gray-600 mb-6">Are you sure you want to log out?</p>
            <div className="flex justify-end space-x-4">
              <button
                onClick={() => setShowConfirmModal(false)}
                className="px-4 py-2 text-gray-600 hover:text-gray-800 text-sm"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  localStorage.clear();
                  sessionStorage.clear(); // Optional if used
                  setShowConfirmModal(false);
                  navigate("/"); // or window.location.href = "/";
                }}
                className="px-4 py-2 bg-red-500 text-white text-sm rounded hover:bg-red-600"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default Account;
